import { ButtonStyled } from "theme/common/Button.styled"
import { IconArrowLeft } from "theme/common/Icon.styled"
import { useHistory } from "react-router-dom"
import HomeButtonStyled from "./HomeButton.styled"

const HomeBotton = ({ onClickBackBotton }: { onClickBackBotton?: () => void }) => {
  const history = useHistory()

  const handleClickBackHome = () => {
    history.push("/")
    onClickBackBotton && onClickBackBotton()
  }

  return (
    <HomeButtonStyled>
      <ButtonStyled variant="secondary" onClick={handleClickBackHome}>
        <IconArrowLeft />
        <span>Volver al inicio</span>
      </ButtonStyled>
    </HomeButtonStyled>
  )
}

export default HomeBotton
